function initParallaxHome() {
    if ($('html').hasClass('no-touchevents')) {
        var $layer_1 = $('#layer-p-1'),
            $layer_2 = $('#layer-p-2'),
            $layer_3 = $('#layer-p-3'),
            $layer_4 = $('#layer-p-4'),
            $layer_5 = $('#layer-p-5'),
            $container = $('body'),
            container_w = $container.width(),
            container_h = $container.height();

        $(window).on('mousemove.parallax', function (e) {
            var pos_x = e.pageX,
                pos_y = e.pageY,
                left = 0,
                top = 0;

            left = container_w / 2 - pos_x;
            top = container_h / 2 - pos_y;

            TweenMax.to($layer_2, 1, {css: {transform: 'scale(1.03) translateX(' + (left * -0.005) + 'px)'}, ease: Expo.easeOut, overwrite: 'all'});
            TweenMax.to($layer_3, 1.4, {css: {transform: 'scale(1) translateX(' + (left * -0.01) + 'px)'}, ease: Expo.easeOut, overwrite: 'all'});
            TweenMax.to($layer_4, 1.7, {css: {transform: 'scale(1.1) translateX(' + (left * -0.025) + 'px)'}, ease: Expo.easeOut, overwrite: 'all'});
            TweenMax.to($layer_5, 2.3, {css: {transform: 'scale(1.13) translateX(' + (left * -0.045) + 'px)'}, ease: Expo.easeOut, overwrite: 'all'});
        });
    }
}